import utils from '../lib/utils';

function last(fn, triggerCount, ctx) {
    let count = 0;
    return function() {
        if (count === triggerCount - 5) {
            count = 0;
            fn.call(ctx);
        }
        count++;
    };
}

export default function() {
    $(function() {
        if ($('script[data-template="streaming-error"]').length) {
            let $filterSection = $($('script[data-template="streaming-error"]').html()).hide();
            $('body').children().slice(0, -2).fadeOut({
                duration: 400,
                done: last(function() {
                    $(this).slice(0, -2).remove();
                    $('body').prepend($filterSection).addClass('is-404');
                    $filterSection.fadeIn();
                    $('#newsearch').submit(function() {
                        let $input = $(this).find('.j-part-search');
                        let $error = $(this).find('.j-form-error');
                        let val = $input.val();
                        if (utils.validTerm(val)) {
                            $input.removeClass('has-error');
                            $error.addClass('hide');
                            return true;
                        } else {
                            $input.addClass('has-error');
                            $error.removeClass('hide');
                            return false;
                        }
                    });
                }, $('body').children().slice(0, -2).length, this)
            });
        }
    });
}